export default "/images/vendor/@coreui/icons/svg/flag/cif-iq.svg?7482b5873903c454394deb82adfa40de";